import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const UpdateClientRoleDialog = ({
  open,
  client,
  roles = [],
  loading = false,
  rolesLoading = false,
  onClose,
  onSubmit,
}) => {
  const [selectedRoles, setSelectedRoles] = useState([]);

  const roleOptions = useMemo(() => {
    const fromApi = (roles || []).map((role) =>
      typeof role === "string" ? role : role?.name || role?.role || String(role)
    );
    const current = Array.isArray(client?.roles) ? client.roles : [];
    return Array.from(new Set([...fromApi, ...current].filter(Boolean)));
  }, [client, roles]);

  useEffect(() => {
    if (open) {
      setSelectedRoles(Array.isArray(client?.roles) ? [...client.roles] : []);
    }
  }, [client, open]);

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Update Client Roles</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Assign roles for{" "}
          <strong>{client?.name || client?.clientId || "selected client"}</strong>
        </Typography>
        <Autocomplete
          multiple
          freeSolo
          options={roleOptions}
          value={selectedRoles}
          loading={rolesLoading}
          onChange={(_, value) => setSelectedRoles(value)}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option} label={option} size="small" />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Roles"
              placeholder="Select or type a role"
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={loading || selectedRoles.length === 0}
          onClick={() => onSubmit(selectedRoles)}
        >
          {loading ? "Saving..." : "Save Roles"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateClientRoleDialog;
